// @ts-nocheck
import { APPRADIO_ORIGIN } from "./origins";

function rpOnReady(fn) {
    if (typeof fn !== 'function') return;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
}

export function initProtonWidget() {
    if (typeof window !== 'undefined' && (window.PROton || document.querySelector('.proton-fab'))) return;

/**
 * PROton widget — chat flutuante para Radios.PRO
 *
 * Endpoint: https://agentes.virtues.casa/v2/api/proton/chat
 *
 * Persiste session_id e histórico em sessionStorage (some ao fechar a aba).
 * Detecta automaticamente current_radio_id pela URL /radio/{id}-{slug}.
 * Dispatcha client_actions via CustomEvent para outros scripts do site
 * (radio-manager.js, etc.) capturarem.
 */
(function () {
    'use strict';

    var PROTON_BASE = 'https://agentes.virtues.casa/v2/api/proton';
    var PROTON_CHAT_URL = (function () {
        if (window.PROTON_CHAT_URL) return String(window.PROTON_CHAT_URL);
        return PROTON_BASE + '/chat';
    })();
    var PROTON_WS_URL = (function () {
        if (window.PROTON_WS_URL) return String(window.PROTON_WS_URL);
        return PROTON_BASE.replace(/^http/i, 'ws') + '/ws';
    })();
    var SS_SID_KEY  = 'proton_sid';
    var SS_HIST_KEY = 'proton_history';
    var SS_TOUCHED_KEY = 'proton_touched'; /* 1ª vez = anima pulse no FAB */
    var MAX_HISTORY = 50; /* limite de mensagens guardadas no storage */

    var i18nFallback = {
        fab_label:      'Falar com o PROton',
        title:          'PROton',
        subtitle:       'online · responde em segundos',
        close_aria:     'Fechar',
        placeholder:    'Pergunte algo… (ex: rádios de rock)',
        send_aria:      'Enviar',
        hint:           'IA experimental. Pode errar — confirme dados importantes.',
        welcome:        'Oi! 👋 Sou o PROton. Posso recomendar rádios, mostrar o que está tocando, ajudar a cadastrar uma rádio e mais. O que precisa?',
        suggestions_title: 'Sugestões',
        suggestions: [
            'Sugere uma rádio de rock',
            'Qual rádio tá perto de mim?',
            'Como cadastro minha rádio?',
        ],
        error_network:  'Não consegui falar com o PROton. Tenta de novo daqui a pouco.',
        error_rate:     'Muitas perguntas em pouco tempo. Aguarde {seconds}s e tente de novo.',
        error_generic:  'Algo deu errado. Pode reformular?',
        autoplay_blocked: 'O navegador bloqueou o autoplay. Toque em play no player para ouvir.',
        stop_aria:      'Parar resposta',
        interrupted:    '*interrompido*',
        status_warming: [
            'Conectando ao PROton…',
            'Preparando resposta…',
            'Só um instante…',
        ],
    };

    /* Permite o site sobrescrever via window.PROTON_I18N antes do load. */
    var L = Object.assign({}, i18nFallback, window.PROTON_I18N || {});
    var chatEnabled = L.chat_enabled !== false;

    function applyChatAvailability() {
        if (!drawerEl) return;
        drawerEl.classList.toggle('is-chat-offline', !chatEnabled);
        if (inputEl) {
            inputEl.disabled = !chatEnabled;
        }
        if (sendBtn) {
            sendBtn.disabled = !chatEnabled;
        }
        var dot = drawerEl.querySelector('.proton-drawer__status-dot');
        if (dot) {
            dot.classList.toggle('proton-drawer__status-dot--offline', !chatEnabled);
        }
    }

    /* ===== Estado em sessionStorage ===== */

    function ensureSessionId() {
        try {
            var sid = sessionStorage.getItem(SS_SID_KEY);
            if (!sid) {
                sid = (window.crypto && crypto.randomUUID)
                    ? crypto.randomUUID().replace(/-/g, '')
                    : (Math.random().toString(36).slice(2) + Date.now().toString(36));
                sessionStorage.setItem(SS_SID_KEY, sid);
            }
            return sid;
        } catch (e) {
            return Math.random().toString(36).slice(2);
        }
    }

    var protonPlaybackWs = null;
    var protonPlaybackWsQueue = [];
    var PROTON_WS_QUEUE_LIMIT = 20;

    function buildProtonWsUrl() {
        var url = new URL(PROTON_WS_URL, window.location.href);
        url.searchParams.set('session_id', ensureSessionId());
        return url.toString();
    }

    function flushProtonPlaybackQueue() {
        if (!protonPlaybackWs || protonPlaybackWs.readyState !== WebSocket.OPEN) return;
        while (protonPlaybackWsQueue.length) {
            protonPlaybackWs.send(protonPlaybackWsQueue.shift());
        }
    }

    function handleProtonWsMessage(event) {
        var data = null;
        try {
            data = JSON.parse(event && event.data ? event.data : '{}');
        } catch (e) {
            return;
        }

        if (!data || data.type !== 'assistant_message') return;

        var payload = Object.assign({}, data);
        if (payload.message == null) {
            payload.message = payload.content || payload.text || payload.response || '';
        }

        renderProtonBotReply(payload, {});
    }

    function ensureProtonPlaybackWs() {
        if (!PROTON_WS_URL || !('WebSocket' in window)) return null;
        if (protonPlaybackWs && (
            protonPlaybackWs.readyState === WebSocket.OPEN ||
            protonPlaybackWs.readyState === WebSocket.CONNECTING
        )) {
            return protonPlaybackWs;
        }

        try {
            protonPlaybackWs = new WebSocket(buildProtonWsUrl());
            protonPlaybackWs.addEventListener('open', flushProtonPlaybackQueue);
            protonPlaybackWs.addEventListener('message', handleProtonWsMessage);
            protonPlaybackWs.addEventListener('close', function () {
                protonPlaybackWs = null;
            });
            protonPlaybackWs.addEventListener('error', function () {
                if (protonPlaybackWs && protonPlaybackWs.readyState !== WebSocket.OPEN) {
                    protonPlaybackWs = null;
                }
            });
        } catch (e) {
            protonPlaybackWs = null;
        }

        return protonPlaybackWs;
    }

    function sendPlaybackStateOverWs(detail) {
        var payload = Object.assign({ type: 'stream-state' }, detail || {});
        var message = JSON.stringify(payload);
        var ws = ensureProtonPlaybackWs();

        if (ws && ws.readyState === WebSocket.OPEN) {
            ws.send(message);
            return;
        }

        protonPlaybackWsQueue.push(message);
        if (protonPlaybackWsQueue.length > PROTON_WS_QUEUE_LIMIT) {
            protonPlaybackWsQueue.shift();
        }
    }

    function bindPlaybackStateForwarder() {
        if (bindPlaybackStateForwarder.bound) return;
        bindPlaybackStateForwarder.bound = true;

        document.addEventListener('radiospro:stream-state', function (event) {
            var detail = event && event.detail && typeof event.detail === 'object'
                ? event.detail
                : {};

            try {
                sendPlaybackStateOverWs(detail);
            } catch (e) {
                /* silencioso: stream-state não deve afetar o player/chat */
            }
        });
    }

    bindPlaybackStateForwarder();

    function loadHistory() {
        try {
            var raw = sessionStorage.getItem(SS_HIST_KEY);
            if (!raw) return [];
            var arr = JSON.parse(raw);
            return Array.isArray(arr) ? arr : [];
        } catch (e) { return []; }
    }

    function saveHistory(history) {
        try {
            var trimmed = history.slice(-MAX_HISTORY);
            sessionStorage.setItem(SS_HIST_KEY, JSON.stringify(trimmed));
        } catch (e) { /* quota ou private mode — ignora */ }
    }

    function markTouched() {
        try { sessionStorage.setItem(SS_TOUCHED_KEY, '1'); } catch (e) {}
    }
    function isTouched() {
        try { return sessionStorage.getItem(SS_TOUCHED_KEY) === '1'; } catch (e) { return false; }
    }

    /* ===== Contexto da página ===== */

    function detectCurrentRadioId() {
        /* URL padrão: /radio/{id}-{slug} ou /radio/{id}. NÃO match em
           /radio/app-landing/... porque essa página não tem o widget. */
        var m = location.pathname.match(/^\/radio\/(\d+)(?:-|\/?$)/);
        if (m) return parseInt(m[1], 10);

        if (window.__RADIOPRO_PAGE__ && window.__RADIOPRO_PAGE__.id) {
            return parseInt(window.__RADIOPRO_PAGE__.id, 10) || null;
        }

        var mgr = window.musicPlayerManager;
        if (mgr && mgr.currentRadio && mgr.currentRadio.id) {
            return parseInt(mgr.currentRadio.id, 10) || null;
        }

        var globalPlayer = document.getElementById('radio-global-player');
        if (globalPlayer) {
            var fromData = parseInt(globalPlayer.getAttribute('data-radio-id') || '0', 10);
            if (fromData) return fromData;
        }

        return null;
    }

    function getCurrentUserUid() {
        var m = document.cookie.match(/(?:^|;\s*)RPRO_USER_UID=([^;]+)/);
        if (m) return decodeURIComponent(m[1]);
        /* Fallback: cookie gravado após SSO legado. */
        m = document.cookie.match(/(?:^|;\s*)FIREBASE_UID=([^;]+)/);
        return m ? decodeURIComponent(m[1]) : null;
    }

    function buildContext(extraCoords) {
        var ctx = {
            user_locale: (navigator.language || 'pt-BR'),
            page_url:    location.href,
        };
        var radioId = detectCurrentRadioId();
        if (radioId) ctx.current_radio_id = radioId;
        var uid = getCurrentUserUid();
        if (uid) ctx.user_uid = uid;
        var coords = extraCoords || cachedUserCoords;
        if (coords) ctx.user_coords = coords;
        if (coords && coords.city) ctx.listener_city = coords.city;
        return ctx;
    }

    /* ===== Markup ===== */

    function buildMarkup() {
        var fab = document.createElement('button');
        fab.type = 'button';
        fab.className = 'proton-fab';
        fab.setAttribute('aria-label', L.fab_label);
        fab.setAttribute('aria-haspopup', 'dialog');
        fab.setAttribute('aria-expanded', 'false');
        if (isTouched()) fab.classList.add('is-touched');
        fab.innerHTML =
            '<i class="fa-solid fa-comment-dots" aria-hidden="true"></i>' +
            '<span class="proton-fab__tooltip">' + escapeHtml(L.fab_label) + '</span>';

        var drawer = document.createElement('div');
        drawer.className = 'proton-drawer';
        drawer.id = 'proton-drawer';
        drawer.setAttribute('role', 'dialog');
        drawer.setAttribute('aria-modal', 'true');
        drawer.setAttribute('aria-labelledby', 'proton-drawer-title');
        drawer.setAttribute('aria-hidden', 'true');
        drawer.innerHTML =
            '<div class="proton-drawer__backdrop" data-proton-close tabindex="-1"></div>' +
            '<aside class="proton-drawer__panel" role="document">' +
                '<header class="proton-drawer__header">' +
                    '<div class="proton-drawer__header-waves" id="proton-header-waves" aria-hidden="true"></div>' +
                    '<div class="proton-drawer__header-content">' +
                        '<div class="proton-drawer__avatar"><i class="fa-solid fa-headphones-simple" aria-hidden="true"></i></div>' +
                        '<div class="proton-drawer__head-text">' +
                            '<h2 id="proton-drawer-title" class="proton-drawer__title">' + escapeHtml(L.title) + '</h2>' +
                            '<p class="proton-drawer__subtitle"><span class="proton-drawer__status-dot"></span>' + escapeHtml(L.subtitle) + '</p>' +
                        '</div>' +
                        '<button type="button" class="proton-drawer__close" data-proton-close aria-label="' + escapeAttr(L.close_aria) + '">&times;</button>' +
                    '</div>' +
                '</header>' +
                '<div class="proton-drawer__body" id="proton-body"></div>' +
                '<footer class="proton-drawer__footer">' +
                    '<form class="proton-form" id="proton-form">' +
                        '<textarea class="proton-form__textarea" id="proton-input" rows="1" placeholder="' + escapeAttr(L.placeholder) + '" autocomplete="off"></textarea>' +
                        '<button type="submit" class="proton-form__send" aria-label="' + escapeAttr(L.send_aria) + '">' +
                            '<i class="fa-solid fa-arrow-up proton-form__send-icon proton-form__send-icon--send" aria-hidden="true"></i>' +
                            '<i class="fa-solid fa-stop proton-form__send-icon proton-form__send-icon--stop" aria-hidden="true"></i>' +
                        '</button>' +
                    '</form>' +
                '</footer>' +
            '</aside>';

        document.body.appendChild(fab);
        document.body.appendChild(drawer);
        return { fab: fab, drawer: drawer };
    }

    function escapeHtml(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    function escapeAttr(s) {
        return escapeHtml(s).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    /* ===== Render ===== */

    var bodyEl, inputEl, formEl, fabEl, drawerEl, sendBtn, headerWavesEl;
    var lastFocus = null;
    var isSending = false;
    var userAbortedRequest = false;
    var cachedUserCoords = null; /* preenchido por request_geolocation action */
    var activeRequest = {
        abortController: null,
        reader: null,
        typingEl: null,
        streamBubble: null,
        aborted: false,
        warmingTimer: null,
        warmingIndex: 0,
        hasServerStatus: false,
        retryTimer: null,
        playHints: {
            playRadioId: null,
            radioIds: [],
        },
    };

    var PROTON_CHAT_MAX_ATTEMPTS = 3;
    var PROTON_CHAT_RETRY_DELAYS_MS = [700, 1600, 2800];

    /* ===== Header waves (Vanta.js) ===== */

    var wavesEffect = null;
    var waveAnimId = null;
    var waveBumpTimer = null;
    var waveMode = 'idle';
    var protonThreeRef = null;
    var protonThreeIsolated = null;
    var protonThreeBackup = undefined;
    var protonWaveDepsPromise = null;
    var PROTON_THREE_URL = 'https://cdn.jsdelivr.net/npm/three@0.134.0/build/three.min.js';
    var PROTON_VANTA_URL = 'https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.waves.min.js';
    var waveTargets = { waveHeight: 12, waveSpeed: 0.45, shininess: 28 };
    var waveCurrent = { waveHeight: 12, waveSpeed: 0.45, shininess: 28 };
    var WAVE_PRESETS = {
        idle:      { waveHeight: 12, waveSpeed: 0.45, shininess: 28 },
        typing:    { waveHeight: 20, waveSpeed: 1.2,  shininess: 52 },
        thinking:  { waveHeight: 8,  waveSpeed: 0.22, shininess: 16 },
        streaming: { waveHeight: 10, waveSpeed: 0.38, shininess: 24 },
    };

    function wavesReducedMotion() {
        try {
            return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        } catch (e) {
            return false;
        }
    }

    function applyWavePreset(name) {
        var preset = WAVE_PRESETS[name] || WAVE_PRESETS.idle;
        waveMode = name;
        waveTargets.waveHeight = preset.waveHeight;
        waveTargets.waveSpeed = preset.waveSpeed;
        waveTargets.shininess = preset.shininess;
    }

    function tickWaveLerp() {
        if (!wavesEffect) {
            waveAnimId = null;
            return;
        }
        var k = 0.09;
        waveCurrent.waveHeight += (waveTargets.waveHeight - waveCurrent.waveHeight) * k;
        waveCurrent.waveSpeed += (waveTargets.waveSpeed - waveCurrent.waveSpeed) * k;
        waveCurrent.shininess += (waveTargets.shininess - waveCurrent.shininess) * k;
        wavesEffect.setOptions({
            waveHeight: waveCurrent.waveHeight,
            waveSpeed: waveCurrent.waveSpeed,
            shininess: waveCurrent.shininess,
        });
        waveAnimId = requestAnimationFrame(tickWaveLerp);
    }

    function startWaveLerp() {
        if (waveAnimId) return;
        waveAnimId = requestAnimationFrame(tickWaveLerp);
    }

    function stopWaveLerp() {
        if (waveAnimId) {
            cancelAnimationFrame(waveAnimId);
            waveAnimId = null;
        }
    }

    function loadProtonScript(src) {
        return new Promise(function (resolve, reject) {
            if (document.querySelector('script[data-proton-src="' + src + '"]')) {
                resolve();
                return;
            }
            var s = document.createElement('script');
            s.src = src;
            s.async = true;
            s.dataset.protonSrc = src;
            s.onload = function () { resolve(); };
            s.onerror = function () { reject(new Error('Failed to load: ' + src)); };
            document.head.appendChild(s);
        });
    }

    function pageSharesGlobeThree() {
        return !!document.getElementById('rp-globe-canvas');
    }

    /**
     * Vanta WAVES só funciona com Three ~r134 (quebra em r152+ / globe.gl r171).
     * Carrega r134, guarda referência isolada e restaura window.THREE do globo.
     */
    function loadIsolatedProtonThree() {
        if (protonThreeIsolated) {
            return Promise.resolve(protonThreeIsolated);
        }

        var savedThree = window.THREE;
        var hadGlobalThree = typeof savedThree !== 'undefined' && savedThree !== null;

        return loadProtonScript(PROTON_THREE_URL).then(function () {
            var loaded = window.THREE || null;
            if (!loaded || loaded.REVISION == null) {
                throw new Error('proton_three_load_failed');
            }
            var rev = parseInt(loaded.REVISION, 10);
            if (isNaN(rev) || rev > 140) {
                throw new Error('proton_three_wrong_revision');
            }

            protonThreeIsolated = loaded;
            protonThreeRef = loaded;

            if (hadGlobalThree) {
                window.THREE = savedThree;
                protonThreeBackup = savedThree;
            } else {
                protonThreeBackup = undefined;
                try { delete window.THREE; } catch (e) { window.THREE = undefined; }
            }

            return protonThreeIsolated;
        });
    }

    function isCssWavesStub() {
        return !!(headerWavesEl && headerWavesEl.classList.contains('proton-header-waves--css'));
    }

    function ensureCssWaves() {
        if (!headerWavesEl) return;
        if (wavesEffect && !isCssWavesStub()) return;
        headerWavesEl.classList.add('proton-header-waves--css');
        wavesEffect = {
            destroy: function () {
                if (headerWavesEl) headerWavesEl.classList.remove('proton-header-waves--css');
            },
            resize: function () { /* noop */ },
            setOptions: function () { /* noop */ },
        };
        applyWavePreset('idle');
    }

    function clearCssWavesStub() {
        if (!isCssWavesStub()) return;
        if (wavesEffect && typeof wavesEffect.destroy === 'function') {
            wavesEffect.destroy();
        }
        wavesEffect = null;
    }

    function vantaWavesLooksValid(effect) {
        if (!effect || !headerWavesEl) return false;
        var canvas = headerWavesEl.querySelector('canvas');
        return !!(canvas && canvas.width > 0 && canvas.height > 0);
    }

    function createVantaWavesEffect() {
        if (!headerWavesEl || !protonThreeRef || !window.VANTA || typeof window.VANTA.WAVES !== 'function') {
            return false;
        }

        var effect = null;
        try {
            effect = window.VANTA.WAVES({
                el: headerWavesEl,
                THREE: protonThreeRef,
                mouseControls: true,
                touchControls: true,
                gyroControls: false,
                minHeight: 160,
                minWidth: 200,
                scale: 1.0,
                scaleMobile: 1.0,
                color: 0x14082a,
                shininess: WAVE_PRESETS.idle.shininess,
                waveHeight: WAVE_PRESETS.idle.waveHeight,
                waveSpeed: WAVE_PRESETS.idle.waveSpeed,
                zoom: 0.92,
            });
        } catch (e) {
            return false;
        }

        if (!vantaWavesLooksValid(effect)) {
            if (effect && typeof effect.destroy === 'function') effect.destroy();
            return false;
        }

        clearCssWavesStub();
        wavesEffect = effect;
        applyWavePreset('idle');
        waveCurrent = Object.assign({}, WAVE_PRESETS.idle);
        startWaveLerp();
        return true;
    }

    /** Three r134 isolado + Vanta — nunca usa o Three r171 do globe.gl. */
    function loadProtonWaveDeps() {
        if (protonWaveDepsPromise) return protonWaveDepsPromise;

        protonWaveDepsPromise = loadIsolatedProtonThree().then(function () {
            return loadProtonScript(PROTON_VANTA_URL);
        }).catch(function (err) {
            protonWaveDepsPromise = null;
            throw err;
        });

        return protonWaveDepsPromise;
    }

    function ensureProtonWaves() {
        if (wavesEffect && !isCssWavesStub()) {
            return Promise.resolve();
        }
        if (!headerWavesEl || wavesReducedMotion()) {
            return Promise.resolve();
        }

        ensureCssWaves();

        return loadProtonWaveDeps().then(function () {
            if (!headerWavesEl) return;
            if (!createVantaWavesEffect()) {
                ensureCssWaves();
            }
        }).catch(function () {
            ensureCssWaves();
        });
    }

    function restoreGlobalThreeAfterWaves() {
        if (protonThreeBackup !== undefined) {
            window.THREE = protonThreeBackup;
            return;
        }
        if (pageSharesGlobeThree()) return;
        try { delete window.THREE; } catch (e) { window.THREE = undefined; }
    }

    function destroyProtonWaves() {
        stopWaveLerp();
        if (waveBumpTimer) {
            clearTimeout(waveBumpTimer);
            waveBumpTimer = null;
        }
        if (formEl) formEl.classList.remove('is-typing-active');
        if (wavesEffect) {
            wavesEffect.destroy();
            wavesEffect = null;
        }
        protonWaveDepsPromise = null;
        restoreGlobalThreeAfterWaves();
        waveMode = 'idle';
    }

    function pulseWavesOnTyping() {
        if (isSending) return;
        if (formEl) formEl.classList.add('is-typing-active');
        if (wavesEffect) {
            applyWavePreset('typing');
            waveTargets.waveHeight = Math.min(28, waveTargets.waveHeight + 1.4);
            waveTargets.waveSpeed = Math.min(1.75, waveTargets.waveSpeed + 0.14);
            waveTargets.shininess = Math.min(68, waveTargets.shininess + 5);
        }
        if (waveBumpTimer) clearTimeout(waveBumpTimer);
        waveBumpTimer = setTimeout(function () {
            waveBumpTimer = null;
            if (formEl) formEl.classList.remove('is-typing-active');
            if (wavesEffect && !isSending) applyWavePreset('idle');
        }, 1400);
    }

    function syncWavesWithChatState() {
        if (!wavesEffect) return;
        if (isSending) {
            applyWavePreset(activeRequest.streamBubble ? 'streaming' : 'thinking');
        } else {
            applyWavePreset('idle');
        }
    }

    /**
     * Formata markdown inline simples (apenas asteriscos):
     *   ***x*** → negrito + itálico
     *   **x**   → negrito
     *   *x*     → itálico
     *
     * Importante: escapa HTML PRIMEIRO (anti-XSS), depois aplica
     * substituições em ordem do mais específico ao mais simples
     * (3 → 2 → 1 asteriscos) para evitar conflitos.
     */
    function formatMarkdown(text) {
        var escaped = escapeHtml(text);
        return escaped
            .replace(/\*\*\*([\s\S]+?)\*\*\*/g, '<strong><em>$1</em></strong>')
            .replace(/\*\*([\s\S]+?)\*\*/g, '<strong>$1</strong>')
            .replace(/\*([\s\S]+?)\*/g, '<em>$1</em>');
    }

    function appendBubble(role, text, opts) {
        opts = opts || {};
        var el = document.createElement('div');
        el.className = 'proton-msg proton-msg--' + role;
        /* User/error: texto puro (sem markdown).
           Bot/system: aplica markdown inline para deixar respostas mais
           legíveis sem confiar em HTML arbitrário do agente. */
        if (role === 'bot' || role === 'system') {
            if (opts.plainText) {
                el.textContent = text;
            } else {
                el.innerHTML = formatMarkdown(text);
            }
        } else {
            el.textContent = text;
        }
        bodyEl.appendChild(el);
        if (!opts.skipScroll) scrollToBottom();
        return el;
    }

    /**
     * Remove o bloco de sugestões iniciais do DOM se ainda estiver lá.
     * Chamado assim que o user envia a primeira mensagem — sugestões
     * só fazem sentido no estado vazio. */
    function removeSuggestions() {
        var box = bodyEl.querySelector('.proton-suggestions');
        if (box) box.remove();
    }

    function appendTyping() {
        var el = document.createElement('div');
        el.className = 'proton-typing';
        el.innerHTML =
            '<div class="proton-typing__row">' +
                '<span class="proton-typing__dot"></span>' +
                '<span class="proton-typing__dot"></span>' +
                '<span class="proton-typing__dot"></span>' +
            '</div>' +
            '<p class="proton-typing__status" aria-live="polite"></p>';
        bodyEl.appendChild(el);
        scrollToBottom();
        startWarmingRotator(el);
        return el;
    }

    function getTypingStatusEl(typingEl) {
        return typingEl ? typingEl.querySelector('.proton-typing__status') : null;
    }

    function getWarmingMessages() {
        var list = L.status_warming;
        if (Array.isArray(list) && list.length) {
            return list.map(function (item) { return String(item || '').trim(); }).filter(Boolean);
        }
        return ['Conectando ao PROton…', 'Preparando resposta…'];
    }

    function stopWarmingRotator() {
        if (activeRequest.warmingTimer) {
            clearInterval(activeRequest.warmingTimer);
            activeRequest.warmingTimer = null;
        }
    }

    function fillStatusTextWithLetterFade(textSpan, label) {
        textSpan.setAttribute('data-text', label);
        textSpan.innerHTML = '';
        var chars = Array.from(label);
        var stepMs = 20;
        var maxDelayMs = 420;
        chars.forEach(function (ch, i) {
            var charEl = document.createElement('span');
            charEl.className = 'proton-typing__status-char';
            charEl.setAttribute('aria-hidden', 'true');
            charEl.style.animationDelay = (Math.min(i * stepMs, maxDelayMs) / 1000) + 's';
            if (ch === ' ') {
                charEl.innerHTML = '&nbsp;';
            } else {
                charEl.textContent = ch;
            }
            textSpan.appendChild(charEl);
        });
    }

    function renderTypingStatus(typingEl, text, iconClass) {
        var statusEl = getTypingStatusEl(typingEl);
        if (!typingEl || !statusEl) return;
        var label = String(text || '').trim();
        var icon = String(iconClass || '').trim();
        if (!label) {
            statusEl.hidden = true;
            statusEl.textContent = '';
            statusEl.removeAttribute('data-status-label');
            statusEl.removeAttribute('data-status-icon');
            syncTypingDotsVisibility(typingEl);
            return;
        }

        var prevLabel = statusEl.getAttribute('data-status-label') || '';
        var prevIcon = statusEl.getAttribute('data-status-icon') || '';
        if (label === prevLabel && icon === prevIcon && statusEl.querySelector('.proton-typing__status-text')) {
            statusEl.hidden = false;
            syncTypingDotsVisibility(typingEl);
            return;
        }

        statusEl.setAttribute('data-status-label', label);
        statusEl.setAttribute('data-status-icon', icon);

        var textSpan = statusEl.querySelector('.proton-typing__status-text');
        var iconEl = statusEl.querySelector('i');

        if (!textSpan) {
            var iconHtml = icon
                ? '<i class="' + escapeAttr(icon) + '" aria-hidden="true"></i> '
                : '';
            statusEl.innerHTML = iconHtml + '<span class="proton-typing__status-text"></span>';
            textSpan = statusEl.querySelector('.proton-typing__status-text');
            iconEl = statusEl.querySelector('i');
        } else if (icon) {
            if (!iconEl) {
                var newIcon = document.createElement('i');
                newIcon.className = icon;
                newIcon.setAttribute('aria-hidden', 'true');
                statusEl.insertBefore(newIcon, textSpan);
                statusEl.insertBefore(document.createTextNode(' '), textSpan);
            } else {
                iconEl.className = icon;
            }
        } else if (iconEl) {
            var space = iconEl.nextSibling;
            if (space && space.nodeType === 3 && space.textContent === ' ') {
                space.remove();
            }
            iconEl.remove();
        }

        if (textSpan) {
            fillStatusTextWithLetterFade(textSpan, label);
        }

        statusEl.hidden = false;
        syncTypingDotsVisibility(typingEl);
        scrollToBottom();
    }

    function syncTypingDotsVisibility(typingEl) {
        if (!typingEl) return;
        var statusEl = getTypingStatusEl(typingEl);
        var hasStatus = !!(statusEl && !statusEl.hidden && statusEl.textContent.trim());
        var hasThinking = !!typingEl.querySelector('.proton-typing__thinking');
        typingEl.classList.toggle('proton-typing--has-status', hasStatus || hasThinking);
        typingEl.classList.toggle('proton-typing--has-thinking', hasThinking);
    }

    function startWarmingRotator(typingEl) {
        stopWarmingRotator();
        activeRequest.hasServerStatus = false;
        activeRequest.warmingIndex = 0;
        var messages = getWarmingMessages();
        if (!messages.length || !typingEl) return;

        renderTypingStatus(typingEl, messages[0]);

        activeRequest.warmingTimer = setInterval(function () {
            if (!typingEl.parentNode || activeRequest.hasServerStatus || isRequestAborted()) {
                stopWarmingRotator();
                return;
            }
            activeRequest.warmingIndex = (activeRequest.warmingIndex + 1) % messages.length;
            renderTypingStatus(typingEl, messages[activeRequest.warmingIndex]);
        }, 2800);
    }

    /** Último status do agente (evento SSE `status` / `tool_*`). Descarta anteriores. */
    function setAgentStatus(typingEl, data) {
        if (!typingEl || !data) return;
        stopWarmingRotator();
        activeRequest.hasServerStatus = true;
        var label = data.label || data.summary || data.stage || '';
        if (!label && data.tool) {
            label = String(data.tool).replace(/_/g, ' ');
        }
        var icon = data.icon || '';
        if (!icon && data.tool) {
            icon = 'fa-solid fa-screwdriver-wrench';
        }
        renderTypingStatus(typingEl, label, icon);
    }

    function hideTypingStatus(typingEl) {
        stopWarmingRotator();
        var statusEl = getTypingStatusEl(typingEl);
        if (statusEl) {
            statusEl.hidden = true;
            statusEl.textContent = '';
        }
        syncTypingDotsVisibility(typingEl);
    }

    /** Para o rotator genérico quando chega conteúdo real (token/thinking/tool). */
    function stopStatusOnContentActivity(typingEl) {
        stopWarmingRotator();
        activeRequest.hasServerStatus = true;
    }

    function scrollToBottom() {
        bodyEl.scrollTop = bodyEl.scrollHeight;
        syncBodyScrollFade();
    }

    function syncBodyScrollFade() {
        if (!bodyEl) return;
        bodyEl.classList.toggle('is-scrolled', bodyEl.scrollTop > 8);
    }

    function renderSuggestions() {
        var wrap = document.createElement('div');
        wrap.className = 'proton-suggestions';
        wrap.innerHTML = '<p class="proton-suggestions__title">' + escapeHtml(L.suggestions_title) + '</p>';
        L.suggestions.forEach(function (s) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'proton-suggestion';
            btn.textContent = s;
            btn.disabled = !chatEnabled;
            if (chatEnabled) {
                btn.addEventListener('click', function () {
                    inputEl.value = s;
                    sendMessage(s);
                });
            }
            wrap.appendChild(btn);
        });
        bodyEl.appendChild(wrap);
    }

    function renderHistory() {
        bodyEl.innerHTML = '';
        var history = loadHistory();
        if (history.length === 0) {
            appendBubble('bot', L.welcome);
            return;
        }
        history.forEach(function (m) {
            appendBubble(m.role, m.text, { skipScroll: true });
        });
        scrollToBottom();
    }

    function pushHistory(role, text) {
        var h = loadHistory();
        h.push({ role: role, text: text, ts: Date.now() });
        saveHistory(h);
    }

    /* ===== Networking ===== */

    /**
     * Abre URL imediatamente. Tenta nova aba; se o navegador bloquear,
     * navega na aba atual (sem mostrar link na conversa).
     */
    /**
     * Paths institucionais que vivem em appradio.pro, NÃO em radios.pro.
     * Regra geral: radios.pro = catálogo/rádios; appradio.pro = tudo o
     * que é institucional (suporte, contato, política, fluxo de cadastro
     * e gestão de rádio, planos, etc.). O agente às vezes devolve URL
     * com o domínio errado — normalizamos aqui.
     */
    var APPRADIO_INSTITUTIONAL_PATHS = [
        '/suporte', '/contato', '/politicas', '/etica',
        '/crie_sua_radio', '/painel', '/login', '/registre_sua_radio',
        '/orcamento', '/imprensa', '/midia_kit', '/marketing_digital',
        '/automacao_radio', '/monetizacao', '/appradio', '/servicos',
        '/planos', '/produtos', '/smartphone', '/watch', '/tv_casa',
        '/carro', '/dispositivos_por_voz', '/banco_ideias'
    ];

    function normalizeExternalUrl(url) {
        if (typeof url !== 'string' || !url) return url;
        var u;
        try {
            u = new URL(url, location.origin);
        } catch (e) {
            return url;
        }
        var path = u.pathname || '/';
        var isInstitutional = APPRADIO_INSTITUTIONAL_PATHS.some(function (p) {
            return path === p || path.indexOf(p + '/') === 0;
        });
        if (!isInstitutional) return u.toString();
        return APPRADIO_ORIGIN + path + u.search + u.hash;
    }

    /**
     * Toast com countdown — mostra aviso de 5s antes de abrir o link em
     * nova aba. O utilizador pode acelerar com "Abrir agora" ou abortar
     * com "Cancelar". O countdown dá tempo de ler a mensagem do agente
     * antes da nova aba aparecer.
     */
    var TOAST_COUNTDOWN_SEC = 5;
    var activeToast = null;

    function dismissToast() {
        if (!activeToast) return;
        if (activeToast.intervalId) clearInterval(activeToast.intervalId);
        if (activeToast.timeoutId)  clearTimeout(activeToast.timeoutId);
        if (activeToast.el && activeToast.el.parentNode) {
            activeToast.el.classList.remove('is-visible');
            var el = activeToast.el;
            setTimeout(function () {
                if (el && el.parentNode) el.parentNode.removeChild(el);
            }, 240);
        }
        activeToast = null;
    }

    function openInNewTab(url) {
        var win = null;
        try {
            win = window.open(url, '_blank', 'noopener,noreferrer');
        } catch (e) { /* ignore */ }
        if (win) return;
        /* Pop-up bloqueado: cria link manual na conversa. */
        var fallback = document.createElement('div');
        fallback.className = 'proton-msg proton-msg--bot proton-msg--linkfallback';
        var link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.className = 'proton-msg__link';
        link.innerHTML = '<i class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i> ' + escapeHtml(L.open_link || 'Abrir link');
        fallback.appendChild(link);
        bodyEl.appendChild(fallback);
        scrollToBottom();
    }

    function openExternalLink(rawUrl) {
        if (!rawUrl || typeof rawUrl !== 'string') return;
        var url = normalizeExternalUrl(rawUrl);

        /* Substituição: novo toast cancela o anterior. */
        dismissToast();

        var msgTemplate = L.toast_redirect || 'Abrindo em {seconds}s…';
        var btnOpen     = L.toast_open_now || 'Abrir agora';
        var btnCancel   = L.toast_cancel   || 'Cancelar';
        var secondsLeft = TOAST_COUNTDOWN_SEC;

        var toast = document.createElement('div');
        toast.className = 'proton-toast';
        toast.setAttribute('role', 'status');
        toast.innerHTML =
            '<div class="proton-toast__text">' + escapeHtml(msgTemplate.replace('{seconds}', String(secondsLeft))) + '</div>' +
            '<div class="proton-toast__actions">' +
                '<button type="button" class="proton-toast__btn proton-toast__btn--cancel" data-proton-toast-cancel>' + escapeHtml(btnCancel) + '</button>' +
                '<button type="button" class="proton-toast__btn proton-toast__btn--primary" data-proton-toast-open>' + escapeHtml(btnOpen) + '</button>' +
            '</div>' +
            '<div class="proton-toast__bar"><span class="proton-toast__bar-fill" style="animation-duration: ' + TOAST_COUNTDOWN_SEC + 's"></span></div>';

        var panel = drawerEl.querySelector('.proton-drawer__panel');
        panel.appendChild(toast);
        requestAnimationFrame(function () { toast.classList.add('is-visible'); });

        var textEl = toast.querySelector('.proton-toast__text');
        var intervalId = setInterval(function () {
            secondsLeft--;
            if (secondsLeft <= 0) return;
            textEl.textContent = msgTemplate.replace('{seconds}', String(secondsLeft));
        }, 1000);

        var timeoutId = setTimeout(function () {
            dismissToast();
            openInNewTab(url);
        }, TOAST_COUNTDOWN_SEC * 1000);

        activeToast = { el: toast, intervalId: intervalId, timeoutId: timeoutId };

        toast.querySelector('[data-proton-toast-open]').addEventListener('click', function () {
            dismissToast();
            openInNewTab(url);
        });
        toast.querySelector('[data-proton-toast-cancel]').addEventListener('click', function () {
            dismissToast();
        });
    }

    /**
     * Toca uma rádio dado apenas o ID. O `index.js`/`radio-manager.js`
     * escutam `radio-play` esperando `{ streamUrl, radioId, radioName }`
     * — sem o streamUrl não conseguem inicializar o player. Por isso o
     * widget primeiro busca os dados via radio-search.php?action=get-single
     * e só então dispara o evento com payload completo.
     */
    function playRadioById(radioId) {
        if (!radioId) return;
        var base = (window.APPRADIO_PUBLIC_BASE || '') || '';
        var url  = base + '/ajax/radio-search.php?action=get-single&id=' + encodeURIComponent(radioId);
        fetch(url, { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
                if (!data || !data.success || !data.radio) {
                    appendBubble('error', L.error_generic);
                    return;
                }
                if (!dispatchRadioPlay(data.radio)) {
                    appendBubble('error', L.error_generic);
                }
            })
            .catch(function () {
                appendBubble('error', L.error_network);
            });
    }

    function clearRetryTimer() {
        if (activeRequest.retryTimer) {
            clearTimeout(activeRequest.retryTimer);
            activeRequest.retryTimer = null;
        }
    }

    function delayProtonRetry(ms) {
        return new Promise(function (resolve) {
            clearRetryTimer();
            activeRequest.retryTimer = setTimeout(resolve, ms);
        });
    }

    function isRetryableProtonFailure(data, hasContent) {
        if (hasContent) return false;
        if (!data) return true;
        if (data.error === 'rate_limited') return false;
        if (data.error === 'missing_fields' || data.error === 'invalid_json' || data.error === 'message_too_long') {
            return false;
        }
        var retryableErrors = [
            'upstream_unreachable',
            'upstream_error',
            'timeout',
            'agent_failed',
        ];
        if (data.error && retryableErrors.indexOf(data.error) >= 0) return true;
        if (data.ok === false && !data.message) return true;
        return false;
    }

    function shouldRetryProton(err) {
        if (!err) return true;
        if (err.protonRetry) return true;
        if (err.name === 'AbortError') return false;
        return true;
    }

    function protonRetryError(data, extra) {
        var err = new Error('proton_retry');
        err.protonRetry = true;
        err.protonData = data || null;
        if (extra) Object.assign(err, extra);
        return err;
    }

    function resetProtonTransport() {
        clearRetryTimer();
        if (activeRequest.reader) {
            activeRequest.reader.cancel().catch(function () {});
        }
        activeRequest.reader = null;
        if (activeRequest.abortController) {
            try { activeRequest.abortController.abort(); } catch (e1) { /* ignore */ }
        }
        activeRequest.abortController = null;
        removeStreamBubble();
        activeRequest.hasServerStatus = false;
        activeRequest.warmingIndex = 0;
        resetPlayHints();
    }

    function prepareSilentRetry(typingEl) {
        resetProtonTransport();
        if (typingEl && typingEl.parentNode) {
            startWarmingRotator(typingEl);
        }
    }

    function handleProtonRetryOrFail(message, opts, attempt, err, typingEl) {
        if (isRequestAborted()) return Promise.resolve();
        var nextAttempt = attempt + 1;
        if (nextAttempt < PROTON_CHAT_MAX_ATTEMPTS && shouldRetryProton(err)) {
            var delayMs = PROTON_CHAT_RETRY_DELAYS_MS[attempt] || 2800;
            prepareSilentRetry(typingEl);
            return delayProtonRetry(delayMs).then(function () {
                if (isRequestAborted()) return;
                return runProtonChatAttempt(message, opts, nextAttempt, typingEl);
            });
        }
        removeTypingEl(typingEl);
        removeStreamBubble();
        appendBubble('error', L.error_network);
        // eslint-disable-next-line no-console
        console.warn('[PROton] falha após retries:', err);
        return Promise.resolve();
    }

    function removeStreamBubble() {
        if (activeRequest.streamBubble && activeRequest.streamBubble.parentNode) {
            activeRequest.streamBubble.parentNode.removeChild(activeRequest.streamBubble);
        }
        activeRequest.streamBubble = null;
    }

    function setSendButtonLoading(loading) {
        if (!sendBtn) return;
        sendBtn.classList.toggle('is-loading', !!loading);
        sendBtn.setAttribute('aria-label', loading ? (L.stop_aria || 'Parar resposta') : (L.send_aria || 'Enviar'));
    }

    function resetActiveRequest() {
        stopWarmingRotator();
        clearRetryTimer();
        activeRequest.abortController = null;
        activeRequest.reader = null;
        activeRequest.typingEl = null;
        activeRequest.streamBubble = null;
        activeRequest.warmingIndex = 0;
        activeRequest.hasServerStatus = false;
        resetPlayHints();
    }

    function isRequestAborted() {
        return userAbortedRequest || activeRequest.aborted;
    }

    function finishSending() {
        isSending = false;
        resetActiveRequest();
        setSendButtonLoading(false);
        syncWavesWithChatState();
        if (inputEl) inputEl.focus();
    }

    function cancelActiveRequest() {
        if (!isSending) return;
        userAbortedRequest = true;
        activeRequest.aborted = true;
        clearRetryTimer();
        removeTypingEl(activeRequest.typingEl);
        activeRequest.typingEl = null;
        removeStreamBubble();
        if (activeRequest.reader) {
            activeRequest.reader.cancel().catch(function () {});
        }
        if (activeRequest.abortController) {
            activeRequest.abortController.abort();
        }
        appendBubble('system', L.interrupted || '*interrompido*');
        pushHistory('system', L.interrupted || '*interrompido*');
        finishSending();
    }

    function removeTypingEl(typingEl) {
        stopWarmingRotator();
        if (typingEl && typingEl.parentNode) {
            typingEl.parentNode.removeChild(typingEl);
        }
        return null;
    }

    function resetPlayHints() {
        activeRequest.playHints = { playRadioId: null, radioIds: [] };
    }

    function rememberPlayHintRadioId(radioId) {
        var rid = parseInt(radioId, 10);
        if (!rid || rid <= 0) return;
        if (!activeRequest.playHints) resetPlayHints();
        activeRequest.playHints.radioIds.push(rid);
        activeRequest.playHints.playRadioId = rid;
    }

    function messageImpliesAutoPlay(message) {
        return /\b(tocando|playing|vou tocar|reproduzindo|coloquei (no ar|para tocar)|est[aá] tocando|colocando (no ar|para tocar))\b/i
            .test(String(message || ''));
    }

    function extractPlayIntentStationName(message) {
        var text = String(message || '');
        var direct = text.match(/(?:tocando|playing|vou tocar|reproduzindo|colocando (?:no ar|para tocar))\s+\*{0,2}([^\n(]+?)(?:\*{0,2})?(?:\s*[\(]|\s*$)/i);
        if (direct && direct[1]) return cleanExtractedRadioName(direct[1]);
        var m = text.match(/(?:tocando|playing|vou tocar|reproduzindo|colocando (?:no ar|para tocar))\s+\*{0,2}([^*\n(—–-]+?)(?:\*{0,2}|\s*[\(—–-])/i);
        if (m && m[1]) return m[1].trim();
        m = text.match(/\*\*([^*]{2,80})\*\*/);
        return m && m[1] ? m[1].trim() : '';
    }

    function normalizeRadioName(value) {
        return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    }

    function cleanExtractedRadioName(value) {
        return String(value || '')
            .replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/gu, '')
            .replace(/\s+/g, ' ')
            .trim();
    }

    function normalizeStreamUrl(url) {
        var raw = String(url || '').trim();
        if (!raw) return '';
        if (/^https?:\/\//i.test(raw)) return raw;
        if (raw.charAt(0) === '/') return location.origin + raw;
        return '';
    }

    function pickBestRadioMatch(radios, queryName) {
        if (!Array.isArray(radios) || !radios.length) return null;
        var query = normalizeRadioName(queryName);
        if (!query) return radios[0];

        var exact = null;
        var contains = null;
        for (var i = 0; i < radios.length; i++) {
            var title = normalizeRadioName(radios[i] && radios[i].title);
            if (!title) continue;
            if (title === query) {
                exact = radios[i];
                break;
            }
            if (!contains && (title.indexOf(query) >= 0 || query.indexOf(title) >= 0)) {
                contains = radios[i];
            }
        }
        return exact || contains || radios[0];
    }

    function dispatchRadioPlay(radio) {
        if (!radio) return false;
        var radioId = parseInt(radio.id, 10);
        if (!radioId) return false;

        var streamUrl = '';
        if (Array.isArray(radio.streams)) {
            for (var i = 0; i < radio.streams.length; i++) {
                var s = radio.streams[i];
                if (s && typeof s.url === 'string') {
                    streamUrl = normalizeStreamUrl(s.url);
                    if (!streamUrl) continue;
                    break;
                }
            }
        }
        if (!streamUrl) return false;

        document.dispatchEvent(new CustomEvent('radio-play', {
            detail: {
                streamUrl: streamUrl,
                radioId: radioId,
                radioName: radio.title || '',
                urlLogo: radio.url_logo || '',
            },
        }));
        return true;
    }

    function searchAndPlayRadioByName(name) {
        var query = String(name || '').trim();
        if (!query) return Promise.resolve(false);

        var base = (window.APPRADIO_PUBLIC_BASE || '') || '';
        var params = new URLSearchParams({
            action: 'search-server',
            title: query,
            limit: '8',
            offset: '0',
        });
        var url = base + '/ajax/radio-search.php?' + params.toString();

        return fetch(url, { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
                if (!data || !data.success || !Array.isArray(data.radios) || !data.radios.length) {
                    return false;
                }
                var match = pickBestRadioMatch(data.radios, query);
                return dispatchRadioPlay(match);
            })
            .catch(function () { return false; });
    }

    function tryFallbackAutoPlay(data, finalMessage) {
        if (!messageImpliesAutoPlay(finalMessage)) return;
        if (data && Array.isArray(data.client_actions)) {
            var hasPlay = data.client_actions.some(function (a) {
                return a && a.action === 'play_radio_in_site';
            });
            if (hasPlay) return;
        }

        var hints = activeRequest.playHints || {};
        var hintedId = hints.playRadioId || (hints.radioIds && hints.radioIds.length
            ? hints.radioIds[hints.radioIds.length - 1]
            : null);

        if (hintedId) {
            playRadioById(hintedId);
            if (window.console && console.info) {
                console.info('[PROton] auto-play fallback via hint radio_id=', hintedId);
            }
            return;
        }

        var stationName = extractPlayIntentStationName(finalMessage);
        if (!stationName) return;

        searchAndPlayRadioByName(stationName).then(function (played) {
            if (played && window.console && console.info) {
                console.info('[PROton] auto-play fallback via search:', stationName);
            }
        });
    }

    function isProtonSuccess(data) {
        return !!(data && (data.ok === true || data.status === 'ok'));
    }

    function renderProtonBotReply(data, state) {
        state = state || {};
        var streamBubble = state.streamBubble || null;
        var streamText = state.streamText || '';
        var typingEl = state.typingEl;

        typingEl = removeTypingEl(typingEl);

        var finalMessage = (data && data.message != null && data.message !== '')
            ? String(data.message)
            : streamText;

        if (finalMessage) {
            if (streamBubble) {
                streamBubble.classList.remove('proton-msg--streaming');
                streamBubble.innerHTML = formatMarkdown(finalMessage);
            } else {
                appendBubble('bot', finalMessage);
            }
            pushHistory('bot', finalMessage);
        }

        if (data && Array.isArray(data.client_actions) && data.client_actions.length) {
            dispatchClientActions(data.client_actions);
        } else {
            tryFallbackAutoPlay(data, finalMessage);
        }

        return { finished: true, typingEl: typingEl, streamBubble: streamBubble, streamText: streamText };
    }

    function tryParseProtonJsonPayload(raw) {
        if (!raw || typeof raw !== 'string') return null;
        var trimmed = raw.trim();
        if (!trimmed || trimmed.charAt(0) !== '{') return null;
        try {
            return JSON.parse(trimmed);
        } catch (e) {
            return null;
        }
    }

    function finalizeStreamWithoutDone(streamBubble, streamText, typingEl) {
        if (!streamText) return false;
        typingEl = removeTypingEl(typingEl);
        if (streamBubble) {
            streamBubble.classList.remove('proton-msg--streaming');
            streamBubble.innerHTML = formatMarkdown(streamText);
        } else {
            appendBubble('bot', streamText);
        }
        pushHistory('bot', streamText);
        return true;
    }

    function consumeProtonSse(response, typingEl) {
        if (!response.body || typeof response.body.getReader !== 'function') {
            return Promise.reject(new Error('streaming_not_supported'));
        }

        var reader = response.body.getReader();
        activeRequest.reader = reader;
        resetPlayHints();
        var decoder = new TextDecoder();
        var buffer = '';
        var rawBody = '';
        var streamBubble = null;
        var streamText = '';
        var finished = false;
        var thinkingText = '';
        var thinkingLabelEl = null;
        var pendingRetry = null;

        function queueSilentRetry(data) {
            if (streamBubble || streamText) return false;
            if (!isRetryableProtonFailure(data, false)) return false;
            pendingRetry = protonRetryError(data);
            finished = true;
            return true;
        }

        function removeThinkingLabel() {
            if (thinkingLabelEl && thinkingLabelEl.parentNode) {
                thinkingLabelEl.parentNode.removeChild(thinkingLabelEl);
            }
            thinkingLabelEl = null;
            thinkingText = '';
            syncTypingDotsVisibility(typingEl);
        }

        function handleEvent(eventName, dataStr) {
            if (userAbortedRequest || activeRequest.aborted || finished) return;
            var data = null;
            try {
                data = JSON.parse(dataStr);
            } catch (e) {
                return;
            }

            /* Eventos adicionados pelo protocolo v2 ─────────────────── */

            if (eventName === 'open' || eventName === 'start') {
                /* Confirma conexão — status virá em eventos seguintes. */
                return;
            }

            if (eventName === 'status' && data) {
                setAgentStatus(typingEl, data);
                return;
            }

            if (eventName === 'context_used' && data) {
                if (data.kind === 'radio' && data.ref != null) {
                    rememberPlayHintRadioId(data.ref);
                }
                return;
            }

            if (eventName === 'tool_end' && data) {
                stopStatusOnContentActivity(typingEl);
                if (data.tool === 'play_radio_in_site') {
                    var playId = (data.args_summary && data.args_summary.radio_id)
                        || data.radio_id
                        || (data.result && data.result.radio_id);
                    rememberPlayHintRadioId(playId);
                }
                if (data.summary) {
                    setAgentStatus(typingEl, data);
                }
                return;
            }

            if (eventName === 'tool_start' && data) {
                stopStatusOnContentActivity(typingEl);
                setAgentStatus(typingEl, data);
                return;
            }

            if (eventName === 'thinking' && data && data.delta) {
                stopStatusOnContentActivity(typingEl);
                hideTypingStatus(typingEl);
                /* Exibe progressivamente o que o agente está "pensando"
                   como texto itálico mudo ao lado dos dots. */
                thinkingText += String(data.delta);
                if (!thinkingLabelEl && typingEl) {
                    thinkingLabelEl = document.createElement('span');
                    thinkingLabelEl.className = 'proton-typing__thinking';
                    var row = typingEl.querySelector('.proton-typing__row');
                    if (row) row.appendChild(thinkingLabelEl);
                    else typingEl.appendChild(thinkingLabelEl);
                }
                if (thinkingLabelEl) {
                    /* Trunca para caber no espaço visual */
                    var display = thinkingText.length > 60
                        ? '…' + thinkingText.slice(-57)
                        : thinkingText;
                    thinkingLabelEl.textContent = display;
                    syncTypingDotsVisibility(typingEl);
                    scrollToBottom();
                }
                return;
            }

            if (eventName === 'thinking_end') {
                removeThinkingLabel();
                return;
            }

            if (eventName === 'text_end' && data && data.content) {
                /* Conteúdo completo chegou — sincroniza a bolha se necessário.
                   O evento 'done' virá logo depois com client_actions. */
                if (streamBubble && data.content !== streamText) {
                    streamText = String(data.content);
                    streamBubble.textContent = streamText;
                    scrollToBottom();
                }
                return;
            }

            if (eventName === 'message_end') {
                /* Sinaliza fim da mensagem — aguardamos 'done' para client_actions. */
                return;
            }

            /* ─────────────────────────────────────────────────────────── */

            if (eventName === 'token' && data) {
                var delta = data.delta != null ? String(data.delta) : '';
                if (delta === '') return;
                stopStatusOnContentActivity(typingEl);
                removeThinkingLabel();
                typingEl = removeTypingEl(typingEl);
                applyWavePreset('streaming');
                streamText += delta;
                if (!streamBubble) {
                    streamBubble = appendBubble('bot', streamText, { plainText: true });
                    streamBubble.classList.add('proton-msg--streaming');
                    activeRequest.streamBubble = streamBubble;
                } else {
                    streamBubble.textContent = streamText;
                }
                scrollToBottom();
                return;
            }

            if ((eventName === 'done' || eventName === 'message') && data && isProtonSuccess(data)) {
                var doneState = renderProtonBotReply(data, {
                    streamBubble: streamBubble,
                    streamText: streamText,
                    typingEl: typingEl,
                });
                finished = doneState.finished;
                typingEl = doneState.typingEl;
                streamBubble = doneState.streamBubble;
                activeRequest.streamBubble = streamBubble;
                return;
            }

            if (eventName === 'error' || (data && data.ok === false)) {
                if (data && data.error === 'rate_limited') {
                    finished = true;
                    typingEl = removeTypingEl(typingEl);
                    var retrySec = data.retry_after || data.retry_after_ms
                        ? Math.ceil((data.retry_after_ms || (data.retry_after * 1000)) / 1000)
                        : 60;
                    appendBubble('error', L.error_rate.replace('{seconds}', retrySec));
                    return;
                }
                if (queueSilentRetry(data)) return;
                finished = true;
                typingEl = removeTypingEl(typingEl);
                if (isProtonSuccess(data) && data.message) {
                    renderProtonBotReply(data, { streamBubble: streamBubble, streamText: streamText, typingEl: typingEl });
                } else {
                    appendBubble('error', L.error_network);
                }
            }
        }

        function parseBlock(block) {
            if (!block || !block.trim()) return;
            var normalized = block.replace(/\r\n/g, '\n');
            var lines = normalized.split('\n');
            var eventName = 'message';
            var dataLines = [];
            lines.forEach(function (line) {
                if (line.indexOf('event:') === 0) {
                    eventName = line.slice(6).trim();
                } else if (line.indexOf('data:') === 0) {
                    dataLines.push(line.slice(5).trim());
                }
            });
            if (!dataLines.length) return;
            handleEvent(eventName, dataLines.join('\n'));
        }

        function finishStream() {
            if (userAbortedRequest || activeRequest.aborted || finished) {
                if (pendingRetry) {
                    return Promise.reject(pendingRetry);
                }
                return;
            }

            if (buffer.trim()) {
                parseBlock(buffer);
            }

            if (pendingRetry) {
                return Promise.reject(pendingRetry);
            }

            if (!finished) {
                var jsonPayload = tryParseProtonJsonPayload(rawBody);
                if (jsonPayload && isProtonSuccess(jsonPayload)) {
                    var jsonState = renderProtonBotReply(jsonPayload, {
                        streamBubble: streamBubble,
                        streamText: streamText,
                        typingEl: typingEl,
                    });
                    finished = jsonState.finished;
                    typingEl = jsonState.typingEl;
                    streamBubble = jsonState.streamBubble;
                    activeRequest.streamBubble = streamBubble;
                } else if (finalizeStreamWithoutDone(streamBubble, streamText, typingEl)) {
                    finished = true;
                    typingEl = null;
                }
            }

            if (!finished && !streamBubble && !streamText && !isRequestAborted()) {
                if (isRetryableProtonFailure(null, false)) {
                    return Promise.reject(protonRetryError(null));
                }
                typingEl = removeTypingEl(typingEl);
                appendBubble('error', L.error_network);
            }
        }

        function pump() {
            return reader.read().then(function (result) {
                if (isRequestAborted()) return;
                if (result.done) {
                    return finishStream();
                }

                var chunkText = decoder.decode(result.value, { stream: true });
                rawBody += chunkText;
                buffer += chunkText;
                var parts = buffer.replace(/\r\n\r\n/g, '\n\n').split('\n\n');
                buffer = parts.pop() || '';
                parts.forEach(parseBlock);
                if (pendingRetry) {
                    return Promise.reject(pendingRetry);
                }
                return pump();
            }).catch(function (err) {
                if (isRequestAborted() || (err && err.name === 'AbortError')) {
                    return;
                }
                if (err && err.protonRetry) {
                    throw err;
                }
                if (!streamBubble && !streamText && isRetryableProtonFailure(null, false)) {
                    throw protonRetryError(null, { cause: err });
                }
                throw err;
            });
        }

        return pump();
    }

    function handleChatResponse(response, typingEl, attempt, message, opts) {
        attempt = attempt || 0;
        message = message || '';
        opts = opts || {};
        if (isRequestAborted()) {
            return Promise.resolve();
        }

        if (response.status === 429) {
            typingEl = removeTypingEl(typingEl);
            var retry = parseInt(response.headers.get('retry-after') || '60', 10);
            appendBubble('error', L.error_rate.replace('{seconds}', retry));
            return Promise.resolve();
        }

        if (response.status >= 502 && response.status <= 504) {
            return Promise.reject(protonRetryError({ error: 'upstream_error', status: response.status }));
        }

        var contentType = (response.headers.get('content-type') || '').toLowerCase();
        if (contentType.indexOf('text/event-stream') !== -1) {
            return consumeProtonSse(response, typingEl).catch(function (err) {
                return handleProtonRetryOrFail(message, opts, attempt, err, typingEl);
            });
        }

        return response.text().then(function (raw) {
            if (isRequestAborted()) return;
            var data = tryParseProtonJsonPayload(raw);
            if (!data) {
                return Promise.reject(protonRetryError(null));
            }
            if (!isProtonSuccess(data)) {
                if (data.error === 'rate_limited') {
                    typingEl = removeTypingEl(typingEl);
                    var retrySec = data.retry_after || data.retry_after_ms
                        ? Math.ceil((data.retry_after_ms || (data.retry_after * 1000)) / 1000)
                        : 60;
                    appendBubble('error', L.error_rate.replace('{seconds}', retrySec));
                    return;
                }
                if (isRetryableProtonFailure(data, false)) {
                    return Promise.reject(protonRetryError(data));
                }
                typingEl = removeTypingEl(typingEl);
                appendBubble('error', L.error_generic);
                return;
            }
            renderProtonBotReply(data, { typingEl: typingEl });
        });
    }

    function runProtonChatAttempt(message, opts, attempt, typingEl) {
        resetProtonTransport();
        activeRequest.typingEl = typingEl;
        activeRequest.abortController = new AbortController();

        return fetch(PROTON_CHAT_URL, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'accept': 'text/event-stream',
            },
            credentials: 'same-origin',
            signal: activeRequest.abortController.signal,
            body: JSON.stringify({
                message: message,
                session_id: ensureSessionId(),
                context: buildContext(opts.userCoords),
                trace: {
                    status: true,
                    tool_calls: true,
                    thinking: false,
                },
            }),
        })
            .then(function (r) {
                return handleChatResponse(r, typingEl, attempt, message, opts);
            })
            .catch(function (err) {
                if (isRequestAborted() || (err && err.name === 'AbortError')) {
                    return;
                }
                return handleProtonRetryOrFail(message, opts, attempt, err, typingEl);
            });
    }

    function dispatchClientActions(actions) {
        if (!Array.isArray(actions)) return;
        actions.forEach(function (a) {
            if (!a || !a.action) return;
            /* Dispatcher: outros scripts do site escutam estes events. */
            document.dispatchEvent(new CustomEvent('proton-action', {
                detail: { action: a.action, args: a.args || {} }
            }));
            /* Tratamento embarcado para ações universais. */
            switch (a.action) {
                case 'navigate_to':
                    if (a.args && a.args.url) {
                        openExternalLink(a.args.url);
                    }
                    break;
                case 'play_radio_in_site':
                    /* Buscar dados da rádio e disparar com payload completo
                       que o radio-manager/index.js espera. */
                    playRadioById(a.args && a.args.radio_id);
                    break;
                case 'pause_radio':
                    /* radio-manager.js usa 'radio-stop' (não 'radio-pause');
                       enviamos ambos por compatibilidade. */
                    document.dispatchEvent(new CustomEvent('radio-stop', {
                        detail: { radioId: window.radioManager && window.radioManager.currentPlayingId }
                    }));
                    document.dispatchEvent(new CustomEvent('radio-pause'));
                    break;
                case 'set_sleep_timer':
                    document.dispatchEvent(new CustomEvent('radio-sleep-timer', {
                        detail: { minutes: a.args && a.args.minutes }
                    }));
                    break;
                case 'request_geolocation':
                    /* Pede permissão de geolocalização; quando aceita,
                       armazena coords para a próxima mensagem. */
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(
                            function (pos) {
                                cachedUserCoords = {
                                    lat: pos.coords.latitude,
                                    lon: pos.coords.longitude,
                                };
                            },
                            function () { /* negado — sem ação */ }
                        );
                    }
                    break;
                default:
                    /* Outros scripts podem tratar via 'proton-action'. */
                    break;
            }
        });
    }

    function sendMessage(text, opts) {
        text = String(text || '').trim();
        if (!chatEnabled || !text || isSending) return;
        opts = opts || {};

        /* Sugestões iniciais somem assim que há uma 1ª mensagem do user. */
        removeSuggestions();

        appendBubble('user', text);
        pushHistory('user', text);
        inputEl.value = '';
        autoResize();
        isSending = true;
        userAbortedRequest = false;
        activeRequest.aborted = false;
        resetActiveRequest();
        setSendButtonLoading(true);
        applyWavePreset('thinking');

        var typingEl = appendTyping();
        activeRequest.typingEl = typingEl;

        runProtonChatAttempt(text, opts, 0, typingEl)
            .finally(function () {
                userAbortedRequest = false;
                activeRequest.aborted = false;
                clearRetryTimer();
                finishSending();
            });
    }

    /* ===== Open/close ===== */

    function openDrawer() {
        if (drawerEl.classList.contains('is-open')) return;
        markTouched();
        fabEl.classList.add('is-touched');
        lastFocus = document.activeElement;
        drawerEl.classList.add('is-open');
        drawerEl.setAttribute('aria-hidden', 'false');
        fabEl.setAttribute('aria-expanded', 'true');
        document.body.classList.add('proton-drawer-open');
        /* Render só na abertura — evita custo se o user nunca abrir. */
        if (bodyEl.children.length === 0) renderHistory();
        requestAnimationFrame(function () {
            ensureProtonWaves();
            if (wavesEffect && typeof wavesEffect.resize === 'function') {
                wavesEffect.resize();
            }
        });
        setTimeout(function () { inputEl.focus(); }, 320);
    }

    function closeDrawer() {
        drawerEl.classList.remove('is-open');
        drawerEl.setAttribute('aria-hidden', 'true');
        fabEl.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('proton-drawer-open');
        destroyProtonWaves();
        /* Cancela qualquer toast de redirect pendente — se o user fechou
           o drawer no meio do countdown, provavelmente desistiu. */
        dismissToast();
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    /* ===== Auto-resize do textarea ===== */

    var MAX_TEXTAREA_PX = 115; /* ~5 linhas com line-height 1.4 e padding atual */

    function autoResize() {
        /* Reset para 'auto' lê o scrollHeight natural sem influência do
           valor anterior. Depois clampa em MAX_TEXTAREA_PX. */
        inputEl.style.height = 'auto';
        var needed = inputEl.scrollHeight;
        var clamped = Math.min(needed, MAX_TEXTAREA_PX);
        inputEl.style.height = clamped + 'px';
        /* Só liga overflow-y quando passa do limite — assim a scrollbar
           custom não aparece quando ainda há espaço. */
        inputEl.style.overflowY = needed > MAX_TEXTAREA_PX ? 'auto' : 'hidden';
    }

    /* ===== Init ===== */

    function init() {
        var els = buildMarkup();
        fabEl = els.fab;
        drawerEl = els.drawer;
        bodyEl = drawerEl.querySelector('#proton-body');
        headerWavesEl = drawerEl.querySelector('#proton-header-waves');
        inputEl = drawerEl.querySelector('#proton-input');
        formEl = drawerEl.querySelector('#proton-form');
        sendBtn = drawerEl.querySelector('.proton-form__send');

        applyChatAvailability();

        bodyEl.addEventListener('scroll', syncBodyScrollFade, { passive: true });

        fabEl.addEventListener('click', openDrawer);
        drawerEl.querySelectorAll('[data-proton-close]').forEach(function (el) {
            el.addEventListener('click', closeDrawer);
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && drawerEl.classList.contains('is-open')) {
                closeDrawer();
            }
        });

        formEl.addEventListener('submit', function (e) {
            e.preventDefault();
            if (isSending) {
                cancelActiveRequest();
                return;
            }
            sendMessage(inputEl.value);
        });

        sendBtn.addEventListener('click', function (e) {
            if (isSending && sendBtn.classList.contains('is-loading')) {
                e.preventDefault();
                cancelActiveRequest();
            }
        });

        inputEl.addEventListener('input', function () {
            autoResize();
            pulseWavesOnTyping();
        });
        inputEl.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                sendMessage(inputEl.value);
                return;
            }
            if (!isSending && e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
                pulseWavesOnTyping();
            }
        });

        /* API pública: outras partes do site podem programaticamente
           pedir ao agente algo (ex.: depois de uma ação que falhou). */
        window.PROton = {
            open: openDrawer,
            close: closeDrawer,
            send: function (msg) {
                if (!chatEnabled) return;
                openDrawer();
                sendMessage(msg);
            },
        };
    }

    if (document.readyState === 'loading') {
        rpOnReady( init);
    } else {
        init();
    }

    document.addEventListener('radio-autoplay-blocked', function () {
        if (!drawerEl || !drawerEl.classList.contains('is-open')) return;
        var hint = L.autoplay_blocked || '';
        if (!hint) return;
        appendBubble('assistant', hint);
        pushHistory('assistant', hint);
    });
})();

}
